<style lang="css">
.chainId-dropdown {
  width: 400px;
  height: 300px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
  position: relative;
}

.chainId-dropdown .ivu-input-wrapper {
  position: absolute;
  right: 10px;
  top: 8px;
  z-index: 999;
}

.chainId-dropdown .ivu-input {
  border-radius: 0;
}
</style>

<template>
  <div>
    <vxe-pulldown ref="sellerDown" transfer>
      <template>
        <a
          class="link-text"
          @click="focusEvent"
          target="_black"
          style="cursor:pointer;display:inline-block;width:100%;text-algin:center;"
        >{{(username == null || username == '') ? placeholder : username}}</a>
      </template>
      <template v-slot:dropdown>
        <div class="chainId-dropdown">
          <Input
            search
            suffix="ios-search"
            v-model="searchName"
            placeholder
            @on-search="search"
            style="width: 200px"
          />
          <vxe-grid
            border="none"
            highlight-hover-row
            auto-resize
            height="auto"
            :loading="loading"
            :pager-config="tablePage"
            :data="tableList"
            :columns="tableColumn"
            @cell-click="cellClickEvent"
            @page-change="pageChange"
          ></vxe-grid>
        </div>
      </template>
    </vxe-pulldown>
  </div>
</template>


<script>
import $api from "@/apiProvider";
import { isEmpty } from "@/utils/util";
export default {
  name: "SalesMan",
  props: {
    row: {
      type: Object,
      default: null,
    },
    field: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "选择客户",
    },
    rowIndex: {
      default: null,
    },
    isEdit:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      searchName: "",
      username: null, // 业务员
      tableColumn: [{ field: "userName", title: "客户" }], // 表格数据列
      tableList: [], // 业务员列表
      loading: false,
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        size: "mini",
      },
    };
  },
  methods: {
    pageChange(e) {
      this.tablePage.currentPage = e.currentPage;
      this.tablePage.pageSize = e.pageSize;
      this.getUserList();
    },
    focusEvent() {
      if(!this.isEdit) return
      this.username = this.row[this.field];
      this.getUserList();
      this.$refs.sellerDown.showPanel();
    },
    search() {
      this.tablePage.currentPage = 1;
      this.getUserList()
    },
    async cellClickEvent({ row }) {
      this.username = row.userName;
      this.row[this.field] = row.userName;
      this.$refs.sellerDown.hidePanel();
    },
    async getUserList() {
      let params = {
        orderBy: 2,
        page: this.tablePage.currentPage,
        rows: this.tablePage.pageSize,
      };
      if (!isEmpty(this.searchName)) {
        params.username = this.searchName;
      }
      if (isEmpty(this.tableList)) {
        this.loading = true;
      }
      let res = await $api.baseUserSign.post("queryUserList", params);
      this.loading = false;
      if (res.status === 1) {
        this.tablePage.total = res.data.total;
        this.tableList = res.data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
  },
};
</script>